import PropTypes from "prop-types";
import React from "react";

// For Table Header Checkbox
function ColumnHeader({
  title,
  id,
  name,
  handleChange,
  checked,
  value,
  disabled,
}) {
  return (
    <th
      scope="col"
      className="relative px-6 py-3 text-left text_theme cursor-pointer"
    >
      <input
        type="checkbox"
        aria-describedby="comments-description"
        name={name}
        id={id}
        value={value}
        disabled={disabled}
        checked={checked}
        onClick={(e) => handleChange(e)}
        className={`focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded ${
          disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
        }`}
      />{" "}
      <label
        htmlFor={name}
        className={`pl-2 ${
          disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
        }`}
      >
        {title}
      </label>
    </th>
  );
}

ColumnHeader.propTypes = {
  title: PropTypes.string,
};

ColumnHeader.defaultProps = {
  title: "",
};

export default ColumnHeader;
